/*
 *  I15HYDROACCUI18n.ts
 *
 *  Created by Sébastien Hecart on 2022-06-18 13:39:25 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

export default {
  I15HYDROACCU_SECTION_0_TITLE: "Calculez le ballon tampon d'hydro accumulation nécessaire à votre chaudière bois",
  I15HYDROACCU_in_puissance: '',
  I15HYDROACCU_in_puissance_0: 'A puissance minimale',
  I15HYDROACCU_in_puissance_1: 'A puissance nominale',
  I15HYDROACCU_SECTION_1_TITLE: '',
  I15HYDROACCU_in_duree_charge_bois: 'Durée charge de bois',
  I15HYDROACCU_in_puissance_chaudiere: 'Puissance chaudière',
  I15HYDROACCU_in_deperdition: 'Déperdition',
  I15HYDROACCU_in_puissance_mini_chaudiere: 'Puissance mini chaudière',
  I15HYDROACCU_res_volume_tampon: 'Volume tampon',
  I15HYDROACCU_SECTION_2_TITLE: '',
  I15HYDROACCU_I04CONVVOLENER: 'Calcul E libéré: Convertir un volume combustible en énergie',
  I15HYDROACCU_in_e_liberee: 'E Libérée par charge bois',
  I15HYDROACCU_in_capacite_eau_chaudiere: "Capacité d'eau chaudière",
  I15HYDROACCU_in_temp_retour: 'Température retour',
  I15HYDROACCU_in_temp_max_stockage: 'Température max de stockage',
  I15HYDROACCU_res_volume_tampon_nominal: 'Volume tampon'
}
